import { User } from 'state/user/UserTypes';
import { FluxStandardAction } from 'state/StateTypes';
import { createReducer } from 'utils';
import * as actionTypes from './UserActionTypes';

export interface UserState {
   //current user that's logged in
   user: User | null;
   profileError: boolean;
   isAuthenticated: boolean;
   verificationCode: string | null;
}
const assignPayloadToState = ({ payload, error }: FluxStandardAction, prop: keyof UserState): Partial<UserState> => ({
   [prop]: error ? null : payload,
   isAuthenticated: !error,
});

const UserReducer = createReducer<UserState, FluxStandardAction>(
   { user: null, profileError: false, isAuthenticated: false, verificationCode: null },
   {
      [actionTypes.USER_SIGN_UP]: (state, action) => ({
         ...state,
         ...assignPayloadToState(action, 'user'),
      }),
      [actionTypes.USER_LOGIN]: (state, action) => ({
         ...state,
         ...assignPayloadToState(action, 'user'),
      }),
      [actionTypes.GET_PROFILE]: (state, action) => ({
         ...state,
         ...assignPayloadToState(action, 'user'),
      }),
      [actionTypes.GET_PROFILE_ERROR]: (state, { error }) => ({
         ...state,
         profileError: !!error,
      }),
      [actionTypes.USER_LOGIN]: (state, action) => ({
         ...state,
         ...assignPayloadToState(action, 'user'),
      }),
      [actionTypes.USER_LOGOUT]: state => ({
         ...state,
         user: null,
         isAuthenticated: false,
         profileError: false,
      }),
   }
);

export default UserReducer;
